import axios, { getData } from 'lib/axios'

export const createJobPosting = async (data) => {
  const response = await axios.post(`/recruitment/job-postings/draft`, data)
  return getData(response)
}

export const getAllJobAds = async (types, total, current, search) => {
  const response = await axios.get(
    `/recruitment/job-postings/types/${types}?total=${total}&page=${current}${search}`
  )
  return getData(response)
}

export const updateJobAds = async (adxJobAdvertisement, action, data) => {
  const response = await axios.put(
    `/recruitment/job-postings/${adxJobAdvertisement}/${action}`,
    data
  )
  return getData(response)
}

export const editJobAds = async (adxJobAdvertisement, data) => {
  const response = await axios.put(`/recruitment/job-postings/${adxJobAdvertisement}/update`, data)
  return getData(response)
}

export const deleteJobAds = async (adxJobAdvertisement) => {
  const response = await axios.delete(`/recruitment/job-postings/${adxJobAdvertisement}`)
  return getData(response)
}

export const getOneJobAds = async (adxJobAdvertisement) => {
  const response = await axios.get(`/recruitment/job-postings/${adxJobAdvertisement}`)
  return getData(response)
}

/**
 * Generates a skill suggestion based on the provided data.
 *
 * @param {{ job_title: string, job_description: string, job_requirements: string }} data - The data used to generate the skill suggestion.
 * @return {Promise<{
 *  success: boolean,
 *  message: string,
 *  data: string[],
 * }>} A promise that resolves with the generated skill suggestion.
 */
export const postGenerateSkillSuggestion = async (data) => {
  const response = await axios.post('/recruitment/skill-suggesstion', data);
  return response ? getData(response) : {}
}

// export const editJobAds = ({ adxJobAdvertisement, data }) => {
//   return axios.put(`/recruitment/job-postings/${adxJobAdvertisement}/update`,data).then(getData)
// }
